import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { MaintenanceExpenseHistoryComponent } from './maintenance-expense-history.component';

const routes: Routes = [{
    path: "maintenance/expense-history", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "", component: MaintenanceExpenseHistoryComponent, data: { module: "Mantenimiento de unidades", accion: "Histórico de gastos de mantenimiento", type: "view" }
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MaintenanceExpenseHistoryRoutingModule { }
